"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgLab = props => (0, jsx_runtime_1.jsx)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24.9,
  height: 24.9
}, props, {
  children: (0, jsx_runtime_1.jsx)("g", Object.assign({
    "data-name": "Group 554"
  }, {
    children: (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 20",
      d: "M9.124 4.95h6.077a1.116 1.116 0 01.873 1.809l-1.061 1.328v3.269l5.048 6.728a1.563 1.563 0 01-1.251 2.5H5.51a1.575 1.575 0 01-.938-.312 1.564 1.564 0 01-.313-2.19l5.049-6.728V8.085L8.249 6.758a1.126 1.126 0 01-.243-.686 1.117 1.117 0 011.112-1.125zm5.609 1.34H9.591l.914 1.145a.67.67 0 01.147.418v3.727a.67.67 0 01-.134.4l-5.183 6.907a.223.223 0 00.179.357h13.3a.224.224 0 00.224-.223.219.219 0 00-.044-.133l-5.183-6.908a.67.67 0 01-.134-.4V7.853a.67.67 0 01.147-.418z",
      fill: "#e1789f"
    }, void 0)
  }), void 0)
}), void 0);

exports.default = SvgLab;